import type { TextComposerSuggestedAction } from "./suggestedActionsSchema";
import { collectProductConsumers } from "../mergeTags/productContexts";
import { collectTileDataItemRefs } from "../mergeTags/productFieldDtl";
import type { ProductGridModelValue } from "@/features/EmailEditor/plugins/productGridConstants";

export function maxSelectableProductIndex(args: {
  bodyText: string;
  defaultModel: ProductGridModelValue;
  model: string;
  suggestions: TextComposerSuggestedAction[];
  selfId?: string;
  selfIndex?: number;
}): number {
  const bodyTotal = collectProductConsumers(args.bodyText, args.defaultModel)
    .filter((entry) => entry.model === args.model)
    .reduce((sum, entry) => sum + entry.maxProducts, 0);

  let maxReferenced = bodyTotal - 1;
  for (const suggestion of args.suggestions) {
    if (args.selfId !== undefined && suggestion.id === args.selfId) continue;
    const url = "url" in suggestion ? suggestion.url : "";
    for (const ref of collectTileDataItemRefs(`${suggestion.text}\n${url}`)) {
      if (ref.model !== args.model) continue;
      maxReferenced = Math.max(maxReferenced, ref.index);
    }
  }

  return Math.max(maxReferenced + 1, args.selfIndex ?? 0);
}
